/**
 * @description Component-PairInfo
 */
import './index.less';

import classNames from 'classnames';
import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import Card from '@/components/Card';
// import CountdownTime from '@/components/CountdownTime';
import { EmptyDataWrap } from '@/components/EmptyDataWrap';
// import LeanMoreToolTip from '@/components/ToolTip/LeanMoreToolTip';
import { PAIR_PAGE_TYPE } from '@/constants/global';
// import { FAQ_LINKS } from '@/constants/links';
import { useCurrentPairBaseInfoFromUrl, useCurrentPairFromUrl } from '@/features/pair/hook';
// import Change24 from '@/pages/components/Change24';
import { useChainId } from '@/hooks/web3/useChain';
import { showProperDateString } from '@/utils/timeUtils';

import Change24 from '../Change24';
// import BackButton from './BackButton';
import { useMockDevTool } from '@/components/Mock';
import SearchPair from '@/components/SearchPair';
import { WrappedBigNumber } from '@/entities/WrappedBigNumber';
import { useIsFetchedPairInfo, useMarketPairInfo, useWatchInstrumentChange } from '@/features/futures/hooks';
import { useFetchFuturesInstrument } from '@/features/futures/query';
import { useTitle } from '@/features/global/hooks';
import { useWatchMarketListChange } from '@/features/market/hooks';
import { useFetchMarketPairList } from '@/features/market/query';
import PairInfoRight from './PairInfoRight';
import PairInfoSkeleton from './PairInfoSkeleton';
interface IPropTypes {
  type?: PAIR_PAGE_TYPE;
  className?: string;
}
const PairInfo: FC<IPropTypes> = function ({ className, type = PAIR_PAGE_TYPE.TRADE }) {
  const chainId = useChainId();

  const navigate = useNavigate();
  const currentPair = useCurrentPairFromUrl(chainId);
  const currentBaseInfo = useCurrentPairBaseInfoFromUrl(chainId);
  const currentMarketPairInfo = useMarketPairInfo(chainId, currentBaseInfo?.instrumentAddr, currentBaseInfo?.expiry);

  const { isMockSkeleton } = useMockDevTool();
  // show pair price in title
  useTitle(
    currentPair?.fairPrice &&
      currentPair?.rootInstrument?.displayBaseToken &&
      currentPair?.rootInstrument?.displayQuoteToken
      ? `${currentPair?.wrapAttribute('fairPrice')?.formatPriceString()} ${
          currentPair?.rootInstrument?.displayBaseToken?.symbol
        }/${currentPair?.rootInstrument?.displayQuoteToken?.symbol}-${showProperDateString({
          expiry: currentPair.expiry,
          format: 'MMDD',
          showShortPerp: true,
        })} | SynFutures`
      : 'SynFutures',
    // { restoreOnUnmount: true },
  );
  // const isFetched = useMarketPairInfoIsFetched(chainId, currentBaseInfo?.instrumentAddr, currentBaseInfo?.expiry);
  const isFetchedPair = useIsFetchedPairInfo(chainId, currentBaseInfo?.instrumentAddr, currentBaseInfo?.expiry);

  // usePollingSingleInstrumentDataOnTradeOrEarn(
  //   chainId,
  //   userAddr,
  //   currentBaseInfo?.instrumentAddr,
  //   currentBaseInfo?.expiry,
  // );
  // useFetchSingleInstrumentDataWhenChangePage(
  //   chainId,
  //   userAddr,
  //   currentBaseInfo?.instrumentAddr,
  //   currentBaseInfo?.expiry,
  // );
  useFetchMarketPairList({ chainId });
  // useWatchMarketListChange(chainId);
  useFetchFuturesInstrument(chainId, currentBaseInfo?.instrumentAddr);
  // useWatchMarketPairInfoChange(chainId, currentBaseInfo?.instrumentAddr, currentBaseInfo?.expiry);
  useWatchMarketListChange(chainId);
  useWatchInstrumentChange(chainId, currentBaseInfo?.instrumentAddr, currentBaseInfo?.expiry);

  // useGetUserProfile();

  useEffect(() => {
    const hash = document.location.hash;
    if (currentPair && !currentPair?.isNormalPair && hash.startsWith('#/earn/')) {
      navigate('/portfolio');
    }
    //  must dep on isNormalPair
  }, [currentPair?.isNormalPair]);

  const isLoading = isMockSkeleton || !isFetchedPair;
  // const isLoading = isMockSkeleton || !isFetched;

  return (
    <>
      <Card className={classNames(className, 'syn-pair-info')}>
        {isLoading && <PairInfoSkeleton />}
        <div className="syn-pair-info-container" style={{ display: isLoading ? 'none' : undefined }}>
          <div className="syn-pair-info-left">
            <SearchPair type={type} />
            <div className="syn-pair-info-left-divider" />
            <div className="syn-pair-info-left-price">
              <div className="syn-pair-info-left-price-top">
                <EmptyDataWrap
                  isLoading={
                    !currentMarketPairInfo?.fairPrice ||
                    WrappedBigNumber.from(currentMarketPairInfo?.fairPrice).isZero()
                  }>
                  {WrappedBigNumber.from(currentMarketPairInfo?.fairPrice || 0).formatPriceNumberWithTooltip()}
                </EmptyDataWrap>
              </div>
              <Change24
                instrumentAddr={currentPair?.instrumentAddr}
                expiry={currentPair?.expiry}
                chainId={chainId}
                priceChange24h={WrappedBigNumber.from(currentMarketPairInfo?.fairPriceChange24h || 0)}
              />
            </div>
          </div>
          <PairInfoRight currentPair={currentPair} type={type} />
        </div>

        {/* <PairNotFound type={type} createOnly={false} /> */}
      </Card>
    </>
  );
};

export default PairInfo;
